import { api } from './client';
import type { AuthTokens, LoginRequest, RefreshRequest } from '@/types/api';

export const authApi = {
  async login(body: LoginRequest): Promise<AuthTokens> {
    const res = await api.post<AuthTokens>('/auth/login', body, {
      headers: { 'X-Skip-Auth': 'true' },
    });
    return res.data;
  },

  async refresh(body: RefreshRequest): Promise<AuthTokens> {
    const res = await api.post<AuthTokens>('/auth/refresh', body, {
      headers: { 'X-Skip-Auth': 'true' },
    });
    return res.data;
  },
};
